// DialogEditInvoice Component

/* eslint indent: 0, react/jsx-indent: 0 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import Dialog from '../../../common/layout/dialog/dialog.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Input from '../../../common/form/input/input.jsx'
import ConfirmDelete from '../../../common/common/confirm_delete/confirm_delete.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'
import AddressSelect from '../../../common/form/address_select/address_select.jsx'
import Select from '../../../common/form/select/select.jsx'
import FormDatePicker from '../../../common/form/form_datepicker/form_datepicker.jsx'
import util from '../../../lib/util.jsx'
import DateUtil from '../../../lib/dateutil.jsx'

class DialogEditInvoice extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      showError: false,
      refNumber: '',
      invoiceId: '',
      contactName: '',
      projectTitle: '',
      dataDate: null,
      contactPersonOptions: [],
      contactPersonId: '',
      addressOptions: [],
      addresses: [],
      address: null,
      invoiceDate: null,
      dueDate: null,
      pdfLanguage: ''
    }

    this.data = {
      pdfLanguages: [
        { label: 'user.profile.optionNederlands', value: 'nl' },
        { label: 'user.profile.optionEnglish', value: 'en' },
        { label: 'user.profile.optionDeutsch', value: 'de' }
      ]
    }

    this._references = {
      refDueDate: React.createRef(),
      referenceNumber: React.createRef(),
      confirmDelete: React.createRef()
    }
  }

  static get propTypes () {
    return {
      onSubmit: PropTypes.func,
      onDelete: PropTypes.func,
      invoicePaymentDays: PropTypes.number,
      showLanguage: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      onSubmit: null,
      onDelete: null,
      invoicePaymentDays: 0,
      showLanguage: false
    }
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._onKeyDown)
  }

  componentWillUnmount () {
    document.body.removeEventListener('keydown', this._onKeyDown)
  }

  _onKeyDown = ev => {
    if (this.state.active && ev.keyCode === 13) {
      this._onFormSubmit(ev)
    }
  }

  show (invoice) {
    FabButtonManager.setVisible(false)

    if (invoice) {
      const defaultPersonId =
        invoice.contactPersonOptions.length > 0
          ? invoice.contactPersonOptions[0].value
          : ''

      this.setState({
        contactName: invoice.contactName,
        projectTitle: invoice.projectTitle,
        invoiceId: invoice.id,
        refNumber: invoice.referenceNo,
        contactPersonOptions: invoice.contactPersonOptions,
        contactPersonId: invoice.contactPerson
          ? invoice.contactPerson
          : defaultPersonId,
        addressOptions: invoice.addressOptions ? invoice.addressOptions : [],
        addresses: invoice.addresses ? invoice.addresses : [],
        address: invoice.contactAddress ? invoice.contactAddress : null,
        dataDate: new Date(),
        invoiceDate: invoice.invoiceDate || null,
        dueDate: invoice.dueDate || null,
        bShowInvoiceDate: invoice.status === 'Draft',
        bShowDueDate: invoice.status === 'Draft',
        pdfLanguage: invoice.pdfLanguage
      })
    }

    this.setState({ active: true })
  }

  hide () {
    FabButtonManager.setVisible(true)
    this.setState({
      active: false,
      invoiceId: '',
      refNumber: '',
      contactName: '',
      projectTitle: '',
      showError: false,
      dataDate: null,
      contactPersonOptions: [],
      contactPersonId: '',
      addressOptions: [],
      addresses: [],
      address: null,
      invoiceDate: null,
      dueDate: null,
      bShowInvoiceDate: '',
      bShowDueDate: '',
      pdfLanguage: ''
    })
  }

  render () {
    const classHeader = !this.state.showError
      ? 'dialogform-header'
      : 'dialogform-header showerr'
    const { showLanguage } = this.props

    return (
      <Dialog active={this.state.active} onClose={this.hide.bind(this)}>
        <div className='dialog-form invoiceedit-form'>
          <div className={classHeader}>
            {!this.state.showError ? (
              <div className='title'>
                <IntlMessage ident='invoice.form.editInvoiceTitle' />
                <span>{this.state.contactName}</span>
                <span className='subinfo'>{this.state.projectTitle}</span>
              </div>
            ) : (
              <div className='info'>
                <IntlMessage ident='invoice.form.editInvoiceErrorInfo' />
              </div>
            )}
            <IconButton
              icon='wizard-close'
              className='modal wizard-close dialog-form-close'
              canHover={false}
              onClick={this._onClickClose.bind(this)}
            />
          </div>
          <div className='dialogform-content'>
            <form
              className='form'
              method='post'
              noValidate
              action='#'
              onSubmit={this._onFormSubmit.bind(this)}
            >
              <div className='form-layout'>
                <div className='layoutcol'>
                  <div className='formsection'>
                    <div className='formrow'>
                      <div className='formcol'>
                        <Input
                          type='text'
                          name='refNumber'
                          value={this.state.refNumber}
                          label='invoice.form.labelPoNumber'
                          ref={this._references.referenceNumber}
                          size={10}
                          maxLength={100}
                          styleDotted
                          onChange={this._onChangeInput.bind(this, 'refNumber')}
                        />
                      </div>
                    </div>
                    {this.state.contactPersonOptions &&
                      this.state.contactPersonOptions.length > 0 && (
                        <div className='formrow'>
                          <div className='formcol'>
                            <Select
                              options={this.state.contactPersonOptions}
                              name='contactPersonId'
                              className='form-dropdown'
                              label='invoice.form.labelContactPerson'
                              value={this.state.contactPersonId}
                              onChange={this._onChangeInput.bind(
                                this,
                                'contactPersonId'
                              )}
                            />
                          </div>
                        </div>
                      )}
                    {showLanguage && this._renderLanguageOptions()}
                    <div className='formrow'>
                      <div className='formcol2'>
                        <AddressSelect
                          addressOptions={this.state.addressOptions}
                          address={this.state.address}
                          onSelectAddress={this._onSelectAddress.bind(this)}
                        />
                      </div>
                      {this.state.bShowInvoiceDate && (
                        <div className='formcol2 editdatecol'>
                          <FormDatePicker
                            label='invoice.form.labelDialogInvoiceDate'
                            placeholder='invoice.form.labelDialogInvoiceDate'
                            showPlaceholder={false}
                            value={this.state.invoiceDate}
                            name='invoiceDate'
                            onChange={this._onChangeDate.bind(
                              this,
                              'invoiceDate'
                            )}
                            onFocus={this._onFocus.bind(this, 'invoiceDate')}
                          />
                        </div>
                      )}
                      {this.state.bShowDueDate && (
                        <div className='formcol2 editdatecol'>
                          <FormDatePicker
                            label='invoice.form.labelDialogDueDate'
                            placeholder='invoice.form.labelDialogDueDate'
                            ref={this._references.refDueDate}
                            showPlaceholder={false}
                            value={this.state.dueDate}
                            name='dueDate'
                            onChange={this._onChangeDate.bind(this, 'dueDate')}
                            onFocus={this._onFocus.bind(this, 'dueDate')}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <IconButton
              type='primary'
              size='big'
              icon='action-delete'
              title='invoice.form.editInvoiceDelete'
              className='actdelete'
              canHover={false}
              onClick={this._clickDelete.bind(this)}
            />
            <IconButton
              type='primary'
              size='big'
              icon='common-success-tick'
              title='invoice.form.editInvoiceSave'
              canHover={false}
              onClick={this._onFormSubmit.bind(this)}
            />
            <ConfirmDelete
              ref={this._references.confirmDelete}
              title='invoice.list.msgOnDelete'
              onClickOk={this._onClickDeleteConfirm.bind(this)}
            />
          </div>
        </div>
      </Dialog>
    )
  }

  _renderLanguageOptions () {
    const { pdfLanguages } = this.data
    return (
      <div className='formrow'>
        <div className='formcol'>
          <Select
            options={pdfLanguages}
            name='pdfLanguage'
            value={this.state.pdfLanguage}
            multilingualOptions
            label='invoice.form.labelPdfLanguage'
            className='form-dropdown'
            onChange={this._onChangePdfLanguage.bind(this, 'pdfLanguage')}
          />
        </div>
      </div>
    )
  }

  /* Event Handlers */
  _onChangeDate (name, value) {
    let dueDate = name === 'dueDate' ? value : this.state.dueDate
    const invoiceDate = name === 'invoiceDate' ? value : this.state.invoiceDate
    const stateObj = { [name]: value }

    if (name === 'invoiceDate') {
      dueDate = DateUtil.addDaysToDate(
        invoiceDate,
        this.props.invoicePaymentDays
      )
      stateObj.dueDate = dueDate
    }

    if (this._references.refDueDate.current) {
      this._references.refDueDate.current.showError(
        this._isDueDateLesserThanInvoiceDate(dueDate, invoiceDate)
      )
    }

    this.setState(stateObj)
  }

  _isDueDateLesserThanInvoiceDate (dueDate, invoiceDate) {
    const dueDateTimeStamp = new Date(dueDate).getTime()
    const invoiceDateTimeStamp = new Date(invoiceDate).getTime()

    if (dueDateTimeStamp < invoiceDateTimeStamp) {
      return true
    }

    if (util.isDateEqual(new Date(dueDate), new Date(invoiceDate))) {
      return false
    }

    return false
  }

  _onFocus (_name, _value) {
    this.setState({ dataDate: new Date() })
  }

  _onSelectAddress (addressType) {
    let address = null

    if (this.state.addresses && this.state.addresses.length > 0) {
      address = _.find(
        this.state.addresses,
        address => address.type.toLowerCase() === addressType
      )
    }

    this.setState({ address: address, dataDate: new Date() })
  }

  _onFormSubmit (ev) {
    ev.preventDefault()
    let noErrors = 0

    if (
      this._references.referenceNumber.current &&
      !this._references.referenceNumber.current.validate()
    ) {
      noErrors++
    }

    if (noErrors === 0) {
      let contactPerson = null
      if (
        this.state.contactPersonId &&
        this.state.contactPersonOptions &&
        this.state.contactPersonOptions.length > 0
      ) {
        contactPerson = _.find(this.state.contactPersonOptions, contact => {
          return contact.value === this.state.contactPersonId
        })
      }

      const invoiceObj = {
        referenceNo: this.state.refNumber,
        contactPerson: contactPerson ? contactPerson.obj : null,
        contactAddress: this.state.address ? this.state.address : '',
        invoiceDate: this.state.invoiceDate ? this.state.invoiceDate : '',
        dueDate: this.state.dueDate ? this.state.dueDate : '',
        id: this.state.invoiceId,
        pdfLanguage: this.state.pdfLanguage
      }

      if (
        this._isDueDateLesserThanInvoiceDate(
          invoiceObj.dueDate,
          invoiceObj.invoiceDate
        ) &&
        this._references.refDueDate.current
      ) {
        this._references.refDueDate.current.showError(true)
      } else if (this.props.onSubmit) {
        this.props.onSubmit(invoiceObj)
      }
    } else {
      this.setState({ showError: true })
    }
  }

  _clickDelete (ev) {
    ev.preventDefault()
    if (this._references.confirmDelete.current) {
      this._references.confirmDelete.current.show()
    }
  }

  _onClickDeleteConfirm (e) {
    e.preventDefault()

    if (this.props.onDelete) {
      this.props.onDelete(this.state.invoiceId)
    }
  }

  _onClickClose (ev) {
    ev.preventDefault()
    this.hide()
  }

  _onChangeInput (name, value) {
    this.setState({ [name]: value })
  }

  _onChangePdfLanguage (name, value) {
    this.setState({ pdfLanguage: value, dataDate: new Date() })
  }
}

export default DialogEditInvoice
